export default __webpack_public_path__ + "static/media/story-content1-bg.a32e4ad2.png";